import React, { useState, useContext, useMemo, useEffect } from "react";
import { useAccountStatistics } from "@/services/IdleResources/getRegionStatistics.repo";
import {
  FilterSearch,
  FilterSearchToggle,
} from "@/components/filter-search/filter-search";
import { Button } from "react-bootstrap";
import styles from "@/page-components/idle-resource/idle.module.css";
import reportStyles from "@/page-components/reporting/reporting.module.css";
import clsx from "clsx";
import Form from "react-bootstrap/Form";
import { ReportingContext } from "../../reporting-context-file";
import { useReportignFilter } from "@/services/reporting/get-filter-data.repo";

const FilterSection = ({ service, name }) => {
  const [selectedTittle, setSelectedTittle] = useState(null);
  const context = useContext(ReportingContext);

  const query = useMemo(() => {
    return {
      service,
      selectedTittle: selectedTittle,
    };
  }, [selectedTittle, service]);

  const { data: dropdown, isLoading } = useReportignFilter(query);

  useEffect(() => {
    context.setSelectGroupBy([]);
    context.setSelectedFrequencyFilter([]);
    context.setSelectedPeriodFilter([]);
  }, [context?.SelectedTab]);

 

  return (
    <>
      <div
        className={styles.filter_main_div}
        style={{ width: "100%", height: "0%" }}
      >
        <span className={reportStyles.filter_name}>Filters</span>
        <Filter
          tittle={"Group By"}
            isLoading={isLoading}
          setSelectedTittle={setSelectedTittle}
            data={dropdown?.data}
          filterType="group_by"
          selectedValues={context.selectGroupBy}
          onSelect={(list) => {
            context?.setSelectGroupBy(list);
          }}
          onRemove={(list) => {
            context?.setSelectGroupBy(list);
          }}
        />

        <Filter
          tittle={"Frequency"}
          isLoading={isLoading}
          setSelectedTittle={setSelectedTittle}
          data={dropdown?.data}
          filterType="frequency"
          selectedValues={context.SelectedFrequencyFilter}
          onSelect={(list) => {
            context?.setSelectedFrequencyFilter(list);
          }}
          onRemove={(list) => {
            context?.setSelectedFrequencyFilter(list);
          }}
        />
        <Filter
          tittle={"Period"}
          isLoading={isLoading}
          setSelectedTittle={setSelectedTittle}
          data={dropdown?.data}
          filterType="period"
          selectedValues={context.SelectedPeriodFilter}
          onSelect={(list) => {
            context?.setSelectedPeriodFilter(list);
          }}
          onRemove={(list) => {
            context?.setSelectedPeriodFilter(list);
          }}
        />

        {/* 
        <div className={styles.dimension_div}>
          <div className={styles.dimension_name_css}>Frequency</div>
          <div className={styles.service_dropdown_box}></div>

          <FilterSearch
            hideSearch
            options={frequencyData?.data}
            displayValue="name"
            selectedValues={frequencyData.data.filter((item) =>
              context?.SelectedFrequencyFilter?.includes(item.id)
            )}
            onSelect={(selectedItem) => {
              context?.setSelectedFrequencyFilter(selectedItem.id);
            }}
            toggle={
              <FilterSearchToggle
                placeholder={
                  context?.SelectedFrequencyFilter?.length
                    ? frequencyData.data
                        .filter((item) =>
                          context.SelectedFrequencyFilter.includes(item.id)
                        )
                        .map((item) => item.name)
                        .join(", ")
                    : "Select Frequency"
                }
              />
            }
          />
        </div>

        <div className={styles.dimension_div}>
          <div className={styles.dimension_name_css}>Period Range</div>
          <div className={styles.service_dropdown_box}></div>

          <FilterSearch
            hideSearch
            options={periodData?.data}
            displayValue="name"
            selectedValues={periodData.data.filter((item) =>
              context?.SelectedPeriodFilter?.includes(item.id)
            )}
            onSelect={(selectedItem) => {
              context?.setSelectedPeriodFilter(selectedItem.id);
            }}
            toggle={
              <FilterSearchToggle
                placeholder={
                  context?.SelectedPeriodFilter?.length
                    ? periodData.data
                        .filter((item) =>
                          context.SelectedPeriodFilter.includes(item.id)
                        )
                        .map((item) => item.name)
                        .join(", ")
                    : "Select Period"
                }
              />
            }
          />
        </div> */}
      </div>
    </>
  );
};

export default FilterSection;

const Filter = ({
  tittle,
  data,
  isLoading,
  setSelectedTittle,
  filterType,
  selectedValues,
}) => {
  const context = useContext(ReportingContext);
  const [tempSelectedValues, setTempSelectedValues] = useState([]);
  const [currentSelectedValues, setCurrentSelectedValues] = useState([]);
  const [applyTrue, setApplyTrue] = useState(false);

  const handleSelect = (selectedList) => {
    if (filterType === "group_by") {
      context.setSelectGroupBy(selectedList);
    }
    if (filterType === "frequency") {
      context.setSelectedFrequencyFilter(selectedList);
    }
    if (filterType === "period") {
      context.setSelectedPeriodFilter(selectedList);
    }
  };

  const handleRemove = (selectedList) => {
    handleSelect(selectedList);
  };

  const handleTittle = (title) => {
    setSelectedTittle(filterType?.toLowerCase());
  };

  const handleApply = () => {
    handleSelect(tempSelectedValues);
    setCurrentSelectedValues(tempSelectedValues);
  };

  const handleCancel = () => {
    setTempSelectedValues(currentSelectedValues);
  };

  useEffect(() => {
    setTempSelectedValues(selectedValues);
    setCurrentSelectedValues(selectedValues);
  }, [selectedValues]);

  return (
    <>
      <div className={clsx(styles.filter_padding_div)}>
        <div className={clsx(styles.dimension_div)}>
          <div className={styles.dimension_name_css}>{tittle}</div>
          <div
            onClick={() => handleTittle(tittle)}
            className={clsx(styles.filter_group_name_css)}
          >
            <FilterSearch
              multiselect={true}
              showApply
              loading={isLoading}
              applyTrue={applyTrue}
              setApplyTrue={setApplyTrue}
              options={(data || []).map((e) => {
                return {
                  id: e.id,
                  name: e.name,
                };
              })}
              selectedValues={tempSelectedValues}
              onSelect={(list) => setTempSelectedValues(list)}
              onRemove={(list) => setTempSelectedValues(list)}
              displayValue="name"
              placeholder="--Select--"
              toggle={
                <>
                  <FilterSearchToggle placeholder={tittle} />
                </>
              }
              onCancel={() => {
                handleCancel();
              }}
              onApply={() => {
                handleApply();
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};
